export const mountKeyParameterByTypeScreen = (key: number) => `idParameterType-${key}`;
